import * as React from "react";

export const WarningIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={17}
    fill="none"
    {...props}
  >
    <path
      fill="#ED6C02"
      stroke="#ED6C02"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.674 14.445h10.652a1 1 0 0 0 .88-1.474l-5.325-9.89a1 1 0 0 0-1.762 0l-5.325 9.89a1 1 0 0 0 .88 1.474Z"
    />
    <path
      fill="#fff"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.82 6.606 8 10.418l.18-3.81a.18.18 0 1 0-.36-.002Z"
    />
    <path
      fill="#fff"
      d="M8 12.914a.625.625 0 1 1 0-1.25.625.625 0 0 1 0 1.25Z"
    />
  </svg>
);
